export const hashFromString = (s) => s
    .split("")
    .reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);
export const hashRot13 = (str) => {
    const input = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const output = "NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm";
    const index = (x) => input.indexOf(x);
    const translate = (x) => (index(x) > -1 ? output[index(x)] : x);
    return str.split("").map(translate).join("");
};
//# sourceMappingURL=hash.js.map